import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDialog,
  MatSelect,
  MatButtonToggleChange,
  //MatCheckboxModule
} from "@angular/material";
import { DiscountGroupPersonEntryComponent } from "../discount-group-person-entry/discount-group-person-entry.component";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { DiscountGroupService } from "src/app/services/http/business/discount-group/discount-group.service";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { DiscountGroupPersonSearchComponent } from "../discount-group-person-search/discount-group-person-search.component";
import { SoundEnum } from "src/app/enums/sound.enum";
import { DiscountGroupPersonStatusComponent } from "../discount-group-person-status/discount-group-person-status.component";
import { environment } from "src/environments/environment";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";

@Component({
  selector: 'app-discount-group-person-list',
  templateUrl: './discount-group-person-list.component.html',
  styleUrls: ['./discount-group-person-list.component.css']
})
export class DiscountGroupPersonListComponent implements OnInit {
  param: any;
  isOwner: boolean;
  errObject: any;
  errors = new Array();
  pageSize: number;
  pageIndex: number;
  companyList: ICompany;
  personDocumentList=[];
  companySelected: String;
  CompanyEncryptId: string;
  filter: any;
  baseUrl= environment.BaaseUrl + "/";

  displayedColumns: string[] = [
    "fullname",
    "nationalCode",
    "file",
    "discountType",
    "status",
    "function"
  ];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    public translate: TranslateService,
    private snackBar: SnackBarService,
    private holdingService: HoldingService,
    private errorService: ErrorsService,
    private companyService: CompanyService,
    private discountGroupService: DiscountGroupService
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.dataSource.paginator = this.paginator;
  }
  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner)
        this.getCompanyList();

    });
  }
  getDefultList(params): void {
    this.companySelected = params;
    this.cidService.setCID(params);
    this.loadRegistration(params);
  }

  getCompanyList() {
    this.companyService.list(0,0).subscribe(res => {
      this.companyList = res.DataList;
      this.getDefultList(this.companyList[0].CompanyEncryptId);
    });
  }

  getColor(statusId) {
    switch (statusId) {
      case 151:
        return "custom-chips primary";
      case 150:
        return "custom-chips warn";
      case 152:
        return "custom-chips accent";
      default:
        return "custom-chips default";
    }
  }

  search() {
    this.dialog
      .open(DiscountGroupPersonSearchComponent, {
        width: '550px',
        data: null
      })
      .afterClosed()
      .subscribe(res => {
        this.filter = res
        this.dataSource = null;
        this.refresh();

      });
  }

  setCid(companyEncryptId: MatSelect) {
    this.dataSource = null;
    this.cidService.setCID(companyEncryptId.value);
    this.loadRegistration(companyEncryptId.value);
  }

  loadRegistration(companyEncryptId: string) {
    this.dataSource = null;
    this.CompanyEncryptId = companyEncryptId;
    this.refresh();
  }

  isAcceptedDocumentStatus(params: Array<any>) {
    params.forEach(element => {
      if (element.DocumentStatusId == 151) {
        element.IsAcceptedDocument = true;
      }
      else if (element.DocumentStatusId == 152) {
        element.IsAcceptedDocument = false;
      }

    });
  }
  convertStringToArray(items):any{
    items.forEach(element => {
      element.Files= JSON.parse(element.Files);
    });
  };

  refresh() {
    this.discountGroupService.listPersonDocument(this.filter).subscribe(res => {
      this.isAcceptedDocumentStatus(res.DataList);
      this.convertStringToArray(res.DataList);
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 1;
      this.paginator.pageSize = 10;
      this.pageIndex = 0;
      this.pageSize = 10;
    });
  }

  paginatorEvent(event) {
    this.discountGroupService.listPersonDocument(this.filter, event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.isAcceptedDocumentStatus(res.DataList);
        this.convertStringToArray(res.DataList);
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
      });
  }

  add() {
    this.dialog.open(DiscountGroupPersonEntryComponent,{
      width:"350px"
    })
      .afterClosed()
      .subscribe(() => {
        this.refresh();
      });
  }

  edit(event: any) {

    this.dialog.open(DiscountGroupPersonEntryComponent, {
      width:"350px",
      data: event
    })
      .afterClosed().subscribe(() => {
        this.refresh();
      });
  }
  //
  onDiscounStatus(status: MatButtonToggleChange, item: any) {
    if (status.value) {
      this.confirmForDiscounStatus(item, "active", status);
    } else {
      this.confirmForDiscounStatus(item, "inActive", status);
    }
  }

  confirmForDiscounStatus(data: any, messageP: string, status: any): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get(`confirm.${messageP}`, {
        name: this.translate.get("label.discountperson") + " " + "'" + data.StudentFullName + "'"
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "350px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        if (status.value) {
          this.dialog.open(DiscountGroupPersonStatusComponent, {
            data: true
          }).afterClosed().subscribe((res) => {

            res.IsAcceptedDocument == null ?
            this.serviceDiscountGroup(data, status.value, res, 151)
            :
            this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
          });
        } else {
          this.dialog.open(DiscountGroupPersonStatusComponent, {
            data: false
          }).afterClosed().subscribe((res) => {

            res.IsAcceptedDocument == null ?
              this.serviceDiscountGroup(data, status.value, res, 152)
              :
              this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
          });
        }
      }
      else {
        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });

        // if (status.value) {
        //   data.IsAcceptedDocument = !status.value;
        // }
        // else {
        //   data.IsAcceptedDocument = !status.value;
        // }

      }
    });
  }

  serviceDiscountGroup(data: any, status: boolean, form: any, documentStatusId: number) {

    let command: any = {
      Id: data.Id,
      DocumentStatusId: documentStatusId,
      Description: form.Description,
      ValidityEndDate: form.ValidityEndDate
    };
    this.discountGroupService.documentConfirmedReject(command).subscribe(
      () => {
        if (status) {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.activeDiscountGroupPerson"),
            "ok", 5000, SoundEnum.beep
          );
        }
        else {
          this.snackBar.OpenSnackBar(
            this.translate.get("success.deactiveDiscountGroupPerson"),
            "ok", 5000, SoundEnum.beep
          );
        }
        this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
      }, err => {
        this.errObject = this.errorService.getError(err);
        this.param = this.errorService.objectError(this.errObject);
        this.errors = this.errorService.returnError(err);
      }

    );
  }
  //
  delete(data: any) {

    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.cancel", {
        name: this.translate.get("label.discount")
      }),
      alert:null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog.open(ConfirmComponent, {
      width: "300px",
      data: confirm
    })
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            this.discountGroupService.documentDelete({ Id: data.Id }).subscribe(() => {

              this.snackBar.OpenSnackBar(
                this.translate.get("success.deleteDiscountGroupPerson"),
                "ok",
                5000,
                SoundEnum.beep
              );
              this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
            }, () => {
              this.snackBar.OpenSnackBar(
                this.translate.get("error.deleteDiscountGroupPerson"),
                "ok",
                5000,
                SoundEnum.beep
              );

            });
          }
        },
        err => {
          this.errorService.recordHasBennUsed(err);
        }
      );
  }

}
